// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Component } from 'react';
import { canPlay } from '../../../constants';
import { defaultProps } from '../props';
import type { BaseReactPlayerProps } from '../types';
import { callPlayer, getSDK, randomString } from '../utils';

const SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
const SDK_GLOBAL = 'FB';
const SDK_GLOBAL_READY = 'fbAsyncInit';
const PLAYER_ID_PREFIX = 'facebook-player-';

export class Facebook extends Component<BaseReactPlayerProps> {
  static defaultProps = defaultProps;

  static canPlay = canPlay.facebook;

  static loopOnEnded = true;

  callPlayer = callPlayer;

  playerID =
    this.props.config.facebook.playerId ||
    `${PLAYER_ID_PREFIX}${randomString()}`;

  componentDidMount() {
    this.props.onMount?.(this);
  }

  load(url, isReady) {
    if (isReady) {
      getSDK(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then((FB) =>
        FB.XFBML.parse()
      );
      return;
    }

    getSDK(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then((FB) => {
      const {
        onLoaded,
        onReady,
        onPlay,
        onPause,
        onError,
        onEnded,
        onBuffer,
        onBufferEnd,
        muted,
        config
      } = this.props;

      FB.init({
        appId: config.facebook.appId,
        xfbml: true,
        version: config.facebook.version
      });

      FB.Event.subscribe('xfbml.render', () => {
        // Here we know the SDK has loaded, even if onReady/onPlay
        // is not called due to a video that cannot be embedded
        onLoaded();
      });

      FB.Event.subscribe('xfbml.ready', (msg) => {
        if (msg.type === 'video' && msg.id === this.playerID) {
          this.player = msg.instance;
          this.player.subscribe('startedPlaying', onPlay);
          this.player.subscribe('paused', onPause);
          this.player.subscribe('finishedPlaying', onEnded);
          this.player.subscribe('startedBuffering', onBuffer);
          this.player.subscribe('finishedBuffering', onBufferEnd);
          this.player.subscribe('error', onError);

          if (!muted) {
            // Player is muted by default
            this.callPlayer('unmute');
          }

          onReady();

          // For some reason Facebook have added `visibility: hidden`
          // to the iframe when autoplay fails, so here we set it back
          const playerIframe = document
            .getElementById(this.playerID)
            .querySelector('iframe');
          playerIframe.style.visibility = 'visible';
        }
      });
    });
  }

  play() {
    this.callPlayer('play');
  }

  pause() {
    this.callPlayer('pause');
  }

  stop() {
    // Nothing to do
  }

  seekTo(seconds) {
    this.callPlayer('seek', seconds);
  }

  setVolume(fraction) {
    this.callPlayer('setVolume', fraction);
  }

  mute = () => {
    this.callPlayer('mute');
  };

  unmute = () => {
    this.callPlayer('unmute');
  };

  getDuration() {
    return this.callPlayer('getDuration');
  }

  getCurrentTime() {
    return this.callPlayer('getCurrentPosition');
  }

  getSecondsLoaded() {
    return null;
  }

  render() {
    const { url, playing, controls } = this.props;
    const style = {
      width: '100%',
      height: '100%'
    };

    return (
      <div
        style={style}
        id={this.playerID}
        className="fb-video"
        data-href={url}
        data-autoplay={playing ? 'true' : 'false'}
        data-allowfullscreen="true"
        data-controls={controls ? 'true' : 'false'}
      />
    );
  }
}
